import { SHOW_PRICING } from "@/config/cta";

export const NAV_LINKS = [
  { label: "How It Works", id: "how-it-works", testId: "nav-link-how-it-works" },
  { label: "Why KeepThis!", id: "why-keepthis", testId: "nav-link-why-keepthis" },
  { label: "Memories", id: "memories", testId: "nav-link-memories" },
  ...(SHOW_PRICING ? [{ label: "Pricing", id: "pricing", testId: "nav-link-pricing" }] : []),
];

export const STEPS = [
  { n: "01", title: "Snap it", text: "Photograph schoolwork, artwork, and special creations.", accent: "#0CA6A2" },
  { n: "02", title: "Save its story", text: "Add the details that make each memory meaningful.", accent: "#F3BE78" },
  { n: "03", title: "Revisit it", text: "Keep a beautiful digital collection of childhood memories.", accent: "#E8A9A2" },
];

export const BENEFITS = [
  {
    key: "preserve",
    title: "Preserve childhood creations",
    text: "Crayon suns, glitter cards and clay creatures—kept as clear photos that won't fade, tear or get lost in a drawer.",
    image: "/images/drawing.webp",
    span: "md:col-span-2",
    tone: "bg-white",
  },
  {
    key: "stories",
    title: "Remember the stories behind them",
    text: "Note who made it, how old they were, and what they said about it—the part paper never holds on to.",
    span: "md:col-span-1",
    tone: "bg-gold/25",
  },
  {
    key: "clutter",
    title: "Reduce physical paper clutter",
    text: "Clear the fridge door and the overflowing art box with less guilt, because what matters is already kept.",
    span: "md:col-span-1",
    tone: "bg-coral/25",
  },
  {
    key: "revisit",
    title: "Revisit meaningful moments",
    text: "Look back on a whole childhood of creations whenever you want—a little time travel in your pocket.",
    image: "/images/ocean.webp",
    span: "md:col-span-2",
    tone: "bg-navy",
  },
];

export const MEMORIES = [
  { title: "Our Family & Biscuit", child: "Sample child, age 5", kind: "Drawing", note: "“That's Biscuit. He's smiling because it's his birthday too.”", image: "/images/drawing.webp", rotate: -2 },
  { title: "My Solar System", child: "Sample child, grade 3", kind: "School project", note: "Painted every planet twice to get Saturn's rings just right.", image: "/images/project.webp", rotate: 1.5 },
  { title: "First Time Writing My Name", child: "Sample child, age 4", kind: "Milestone", note: "Gold star day. Wrote it on everything for a week.", image: "/images/letters.webp", rotate: -1 },
  { title: "Shelly the Turtle", child: "Sample child, age 6", kind: "Craft", note: "Made in art club. Insists Shelly is a very fast turtle.", image: "/images/clay.webp", rotate: 2 },
  { title: "My Ocean", child: "Sample child, age 7", kind: "Painting", note: "The whale is spouting because he's happy.", image: "/images/ocean.webp", rotate: -1.5 },
  { title: "Happy Birthday Mom", child: "Sample child, age 6", kind: "Card", note: "Hidden under a pillow until breakfast. Extra glitter.", image: "/images/birthday.webp", rotate: 1 },
];

export const MARQUEE = [
  "Keep the memory",
  "Toss the clutter",
  "Save the story",
  "Snap it",
  "Revisit it",
  "Make room for more",
];

export const TIMELINE = [
  { age: 3, title: "The Big Yellow Sun", note: "Mostly scribbles, one very confident sun. Announced as “a picture of everything.”" },
  { age: 4, title: "Me, With Big Arms", note: "The first person appears: a round head with arms straight out for hugs." },
  { age: 5, title: "Our House", note: "Now there's a roof, a door, a tree, and the whole family holding hands." },
  { age: 6, title: "My Dog in the Garden", note: "Flowers in a row, a rainbow on top, and a dog with a very happy tail." },
  { age: 7, title: "Sailing Away", note: "First watercolor. The waves took three tries and a lot of patience." },
  { age: 8, title: "The Castle Dragon", note: "Scales, smoke and a castle with flags. Every detail had a story." },
  { age: 9, title: "Sunset Street", note: "Buildings that get smaller in the distance. Perspective, figured out." },
  { age: 10, title: "Autumn Fox", note: "A real painting on canvas board. Signed in the corner, like an artist." },
].map((t) => ({ ...t, image: `/images/timeline/age${t.age}.webp` }));

export const LEGAL = [
  { label: "Privacy Policy", path: "/privacy", testId: "footer-privacy-link" },
  { label: "Terms of Service", path: "/terms", testId: "footer-terms-link" },
  { label: "Cookie Policy", path: "/cookies", testId: "footer-cookie-link" },
];
